export enum TradedAssetEnum {
    true = "True",
    false = "False",
}